import { Field, isVoidField } from '@formily/core';
import { observer, useField } from '@formily/react';
import { Editor } from '@wangeditor/editor-for-react';
import React from 'react';
interface Item {
  value: string;
  label: string;
}

interface IProps {
  value?: any;
  onChange?: (items: Item[]) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: any;
  content?: string;
}

const Cmp = (props: any) => {
  return <div>{props.value}</div>;
};

export const RichText: React.FC<IProps> = observer((props) => {
  const { style } = props;
  const field: any = useField<Field>();
  const html = field?.initialValue || '';
  if (!isVoidField(field) && field?.pattern === 'readPretty') {
    return <Cmp />;
  }

  return (
    <div>
      <Editor
        defaultConfig={{
          placeholder: '',
          readOnly: true,
        }}
        value={html}
        mode="default"
        style={style ? style : { minHeight: 24 }}
      />
    </div>
  );
});
export default RichText;